import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const BreakingNewsPresentation = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.breakingNewsPresentation.title')}
      contentType="breakingNewsPresentation"
      description={t('page.breakingNewsPresentation.desc')}
      outputLabel={t('page.breakingNewsPresentation.output')}
    />
  );
};
